// extracted by mini-css-extract-plugin
module.exports = {"feed":"Feed_feed__23wlF","feed_videos_heading":"Feed_feed_videos_heading__ffhA3"};